var exports = {
  "kL": "SwitchGroup.module__container___Q01xX0",
  "AS": "SwitchGroup.module__item___Q01xX0",
  "Ly": "SwitchGroup.module__itemContent___Q01xX0",
  "IR": "SwitchGroup.module__itemLabel___Q01xX0",
  "a": "SwitchGroup.module__itemLabelInteractive___Q01xX0",
  "r9": "SwitchGroup.module__disabled___Q01xX0",
  "QK": "SwitchGroup.module__labelText___Q01xX0",
  "LE": "SwitchGroup.module__shortcut___Q01xX0",
  "ce": "SwitchGroup.module__extraContent___Q01xX0",
};

module.exports = exports;
